import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import Profile from "../screens/Profile/PersonalDetails/PersonalDetails";
import Address from "../screens/Profile/Address/AddressPage";
import ProfilePage from "../screens/Profile/ProfilePage";
import PersonalDetails from "../screens/Profile/PersonalDetails/PersonalDetails";
import BankDetails from "../screens/Profile/BankDetails/ProfileBankDetails";
import IraAccount from "../screens/Profile/IraAccount/IraAccountPage";
import PersonalDetailsView from "../screens/Profile/PersonalDetails/PersonalDetailsView";
import SpouseLinkingPage from "../screens/Profile/SpouseLink/SpouseLinkingPage";

const Stack = createStackNavigator();

const ProfileStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Profiles" component={ProfilePage} />
      <Stack.Screen name="PersonalDetails" component={PersonalDetails} />
      <Stack.Screen name="Address" component={Address} />
      <Stack.Screen name="SpouseLinking" component={SpouseLinkingPage} />
      <Stack.Screen name="BankDetails" component={BankDetails} />
      <Stack.Screen name="IraAccount" component={IraAccount} />
    </Stack.Navigator>
  );
};

export default ProfileStackNavigator;
